import InsightsFlexibleFeatures from './InsightsFlexibleFeatures';

export { type InsightsFlexibleFeaturesProps } from './InsightsFlexibleFeatures';
export default InsightsFlexibleFeatures;
